import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { getSpacing } from "@faire/web--source/slate/spacing";
import * as React from "react";
export var DropdownChevron = function(param) {
    var value = param.value, onClear = param.onClear, disabled = param.disabled;
    if (value && onClear) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Chevron, {
        direction: "down",
        width: "8",
        height: "8",
        color: disabled ? Core.icon.disabled : Core.icon.default,
        strokeWidth: 2,
        margin: getSpacing(0, 0, 0, "1x")
    });
};
